// eslint-disable-next-line no-restricted-imports
import { OperationFragment } from 'api/generated/graphql';
import {
  OperationEntity,
  OperationExecutionMethod,
  OperationStatusType,
  OperationType,
} from 'api/types/entity/operation';
import { lodash } from 'helpers';

import { parseFileDocumentEntity } from '../client/parseEntity/parseFileEntity';
import { parseExecutionPlaceEntity } from '../parseExecutionPlaceEntity';
import { parseManagerData } from '../parseManagerData';

import { parseOperationOrderEntity } from './parseOperationOrderEntity';

export const parseOperationEntity = (
  operation: OperationFragment
): OperationEntity => ({
  id: operation.id,
  createdAt: new Date(operation.createdAt),
  versionNumber: operation.version?.number,
  type: OperationType[operation.type],
  status: OperationStatusType[operation.status],
  order: parseOperationOrderEntity(operation.order!),
  number: operation.number,
  executedAt: new Date(operation.executedAt),
  executionMethod: OperationExecutionMethod[operation.executionMethod],
  executionPlace: operation.executionPlace
    ? parseExecutionPlaceEntity(operation.executionPlace)
    : undefined,
  isSpecializedTrade: operation.isSpecializedTrade,
  trader: operation.trader ? parseManagerData(operation.trader) : undefined,
  counterpartyName: operation.counterpartyName,
  quantity: operation.quantity ?? undefined,
  netUnitPrice: operation.netUnitPrice,
  unitPrice: operation.unitPrice ?? undefined,
  accruedCouponIncome: operation.accruedCouponIncome ?? undefined,
  volume: operation.volume ?? undefined,
  settlementDate: new Date(operation.settlementDate),
  exchangeRate: operation.exchangeRate ?? null,
  confirmationFiles: lodash
    .compact(operation.confirmationDocuments)
    .map((doc) => parseFileDocumentEntity(doc)),
  additionalNotes: operation.additionalNotes ?? null,
});
